<template>
  <section class="kub-color pb-5">
    <div class="kub-description-background d-flex align-items-center">
      <div class="kub-description-opacity-mask d-flex align-items-center">
        <div>
          <h1 class="kub-description-title">{{desc.title}}</h1>
          <p class="kub-description-text mt-4 mb-1">{{desc.desc}}</p>
          <p class="kub-description-text mb-0" :class="{'d-none': !xl}">{{desc.subdesc}}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DataDescription from '../../data/general/description'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      desc: DataDescription.description
    }
  },
  computed: {
    ...mapGetters([
      'xs',
      'sm',
      'md',
      'lg',
      'xl'
    ])
  }
}
</script>

<style scoped>
section {
  margin-left: -35px !important;
  margin-right: -35px !important;
  margin-top: -20px;
}

.kub-description-background {
  background-image: url('../../assets/img/background/backgroundDescMobile.jpg');
  background-color: #ddd;
  height: 300px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.kub-description-opacity-mask {
  position: absolute;
  max-width: 100%;
  height: 100%;
  padding: 1.5rem 35px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
}

.kub-description-title {
  font-size: 1.5rem;
}

.kub-description-text {
  font-size: 1rem;
}

@media (min-width: 768px) {
  .kub-description-background {
    background-image: url('../../assets/img/background/backgroundDescTablet.jpg');
  }

  .kub-description-opacity-mask {
    max-width: 80%;
    height: auto;
  }
}

@media (min-width: 992px) {
  .kub-description-opacity-mask {
    max-width: 70%;
  }
}

@media (min-width: 1200px) {
  .kub-description-title {
    font-size: 2rem;
  }

  .kub-description-text {
    font-size: 1.1rem;
  }

  .kub-description-opacity-mask {
    max-width: 60%;
  }
}

@media (min-width: 1400px) {
  .kub-description-background {
    background-image: url('../../assets/img/background/backgroundDescDesktop.jpg');
    background-attachment: fixed;
  }
}
</style>
